import {
  setIsSigningOut,
  clearAuth,
  setShowPersonnelNotFound,
  setShowEmailVerification,
  setShowAcknowledgement,
  setBackendSignInError,
  setLoading,
  setPendingAccessToken,
  signInToBackend,
  checkEmailVerification,
  resendVerificationEmail as resendVerificationEmailThunk,
} from '../slices/authSlice';
import { storage } from '../../utils/storage';
import { auth0Config } from '../../config/auth0Config';

export const signOut = (auth0Logout, auth0IsAuthenticated, apiSignOut = null) => {
  return async (dispatch) => {
    dispatch(setIsSigningOut(true));
    dispatch(setShowPersonnelNotFound(false));
    dispatch(setShowEmailVerification(false));
    dispatch(setShowAcknowledgement(false));
    dispatch(setBackendSignInError(null));
    if (apiSignOut) {
      try {
        await apiSignOut({}, {}, {});
      } catch (_) {
      }
    }
    dispatch(clearAuth());
    storage.removeAuth();
    localStorage.removeItem('comphub_auth0_config');
    if (auth0IsAuthenticated && auth0Logout) {
      try {
        await auth0Logout({
          logoutParams: {
            returnTo: window.location.origin,
          },
        });
      } catch (_) {
        dispatch(setIsSigningOut(false));
        dispatch(setShowPersonnelNotFound(false));
        dispatch(setShowEmailVerification(false));
      }
    } else {
      dispatch(setIsSigningOut(false));
    }
  };
};

export const handleResendVerification = (
  pendingAccessToken,
  resendVerificationEmail,
  getAccessTokenSilently,
  auth0IsAuthenticated
) => {
  return async (dispatch) => {
    let accessToken = pendingAccessToken;

    if (!accessToken && auth0IsAuthenticated && getAccessTokenSilently) {
      try {
        accessToken = await getAccessTokenSilently({
          audience: auth0Config.authorizationParams.audience,
          scope: 'openid profile email offline_access',
          detailedResponse: false,
        });
        if (accessToken) {
          dispatch(setPendingAccessToken(accessToken));
        }
      } catch (_) {
        return {
          success: false,
          message: 'Unable to get access token. Please try logging in again.',
        };
      }
    }

    if (!accessToken) {
      return {
        success: false,
        message: 'No access token available. Please log in again.',
      };
    }

    try {
      const result = await dispatch(
        resendVerificationEmailThunk({
          pendingAccessToken: accessToken,
          resendVerificationEmail,
        })
      ).unwrap();
      return result;
    } catch (error) {
      return error;
    }
  };
};

export const handleRetryAfterVerification = (
  pendingAccessToken,
  auth0User,
  signIn,
  evalToken
) => {
  return async (dispatch) => {
    if (!pendingAccessToken) {
      return;
    }

    try {
      dispatch(setLoading(true));
      dispatch(setBackendSignInError(null));

      const emailVerified = await dispatch(
        checkEmailVerification({ accessToken: pendingAccessToken, evalToken })
      ).unwrap();

      if (!emailVerified) {
        dispatch(
          setBackendSignInError(
            'Email is still not verified. Please check your inbox and click the verification link.'
          )
        );
        dispatch(setLoading(false));
        return;
      }

      dispatch(setShowEmailVerification(false));

      await dispatch(
        signInToBackend({
          accessToken: pendingAccessToken,
          signIn,
          auth0User,
        })
      ).unwrap();
    } catch (error) {
      dispatch(
        setBackendSignInError(
          error.message || 'Failed to sign in. Please try again.'
        )
      );
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const handleAcknowledge = (acknowledgeTerms) => {
  return async (dispatch) => {
    try {
      await acknowledgeTerms({}, {}, {});
      dispatch(setShowAcknowledgement(false));
      // Set flag to show document signing tour for first-time users
      sessionStorage.setItem('showDocumentTour', 'true');
    } catch (_) {
      dispatch(setShowAcknowledgement(false));
    }
  };
};
